import { Button } from '@material-ui/core';

const UserList = ({users, onEditClick, cookies}) => {

    return (
        <>
            <div className='UserList'>
                <p>Users</p>
                <hr />
                {Object.keys(users).map((key, index) => (<p key={index}>{users[key]}</p>))}
                <Button className={'ui-button' + (cookies['rave_username'] && cookies['rave_username'] !== '' ? '':' ClientIndicatorFlash')} style={{backgroundColor: '#D20000'}} variant="contained" color='secondary' disableElevation onClick={onEditClick}>Edit</Button>
            </div>
        </>

    )
}

export default UserList;